export default __webpack_public_path__ + "static/media/res-project-4.6b2782d1.jpg";